import { Product } from '@/models/Product';


export class OfferService {
	getAliexpressOffers(): Product[] {
		return [{
			asin: 'ALI_01',
			price: '5.92',
			rating: 4.8,
			reviewCount: 142,
			text: 'Fashion Matte Finished Hair Styling Clay Daily Use Mens Hair Clay High Strong Hold Low Shine Hair Styling Wax 100ml / 3.33fl oz',
			produced: 'Preboily',
			link: 'http://s.click.aliexpress.com/e/c3e1yfgy',
			images: [
				'https://ae01.alicdn.com/kf/HTB1jUgStY9YBuNjy0Fgq6AxcXXaE.jpg',
				'https://ae01.alicdn.com/kf/HTB1d271t4SYBuNjSspjq6x73VXaf.jpg'
			]
		}, {
			asin: 'ALI_02',
			price: '12.51',
			rating: 4.7,
			reviewCount: 3189,
			text: 'Xiaomi Electric USB Rechargeable Shaver for Men.',
			produced: 'Xiaomi',
			link: 'https://s.click.aliexpress.com/e/_d8tjR9w',
			images: [
				'https://ae01.alicdn.com/kf/H87eec429a289419c9498ec4d2b2c7605U.jpg',
				'https://ae01.alicdn.com/kf/H1d81c41203d04e5681c177d8836f0567d.jpg',
				'https://ae01.alicdn.com/kf/H4e1e1a9bc9a0406e898d9b19ed63470dd.jpg',
				'https://ae01.alicdn.com/kf/Ha8d1a7a450c2494a9cec14410162615dc.jpg',
				'https://ae01.alicdn.com/kf/Hc767ed338dec4b46a6af3e04893438f4v.jpg',
				'https://ae01.alicdn.com/kf/H7c7f22da34b84ba088309b811a6850c0x.jpg',
				'https://ae01.alicdn.com/kf/Hdc6e2ad06dc8497eadc75a462552e129U.jpg'
			]
		}, {
			asin: 'ALI_03',
			price: '25.11',
			rating: 4.7,
			reviewCount: 460,
			text: '4000W Powerful Professional Salon Hair Dryer Negative Ion Blow Dryer Electric Hairdryer Hot/Cold Wind With Air Collecting Nozzle',
			produced: 'BoPAi',
			link: 'http://s.click.aliexpress.com/e/bAwwyN04',
			images: [
				'https://ae01.alicdn.com/kf/HTB1.9_abv9TBuNjy1zbq6xpepXa7.jpg',
				'https://ae01.alicdn.com/kf/HTB1MU93bwaTBuNjSszfq6xgfpXax.jpg',
				'https://ae01.alicdn.com/kf/HTB1xwaIXYZnBKNjSZFKq6AGOVXa7.jpg',
				'https://ae01.alicdn.com/kf/HTB1Rm15bv9TBuNjy0Fcq6zeiFXah.jpg'
			]
		}, {
			asin: 'ALI_08',
			price: '15.30 - 31.50',
			rating: 4.8,
			reviewCount: 69,
			text: '6-inch salon special hairdressing scissors black faucet hairdresser professional modeling tools barber scissors set razor',
			produced: 'SHARONDS',
			link: 'http://s.click.aliexpress.com/e/b5NA85y8',
			images: [
				'https://ae01.alicdn.com/kf/HTB18YkagborBKNjSZFjq6A_SpXaU/6-inch-salon-special-hairdressing-scissors-black-faucet-hairdresser-professional-modeling-tools-barber-scissors-set-razor.jpg',
				'https://ae01.alicdn.com/kf/HTB1m3EMPXXXXXa3XXXXq6xXFXXX5/228186002/HTB1m3EMPXXXXXa3XXXXq6xXFXXX5.jpg',
				'https://ae01.alicdn.com/kf/HTB1BTaAXizxK1Rjy1zkq6yHrVXaM.jpg'
			]
		}, {
			asin: 'ALI_05',
			price: '19.67',
			rating: 4.8,
			reviewCount: 1684,
			text: 'Kemei KM - 600 Professional Hair Trimmer 6 In 1 Hair Clipper Shaver Sets Electric Shaver Beard Trimmer Hair Cutting Machine',
			produced: 'Kemei',
			link: 'http://s.click.aliexpress.com/e/cVD92zRi',
			images: [
				'https://ae01.alicdn.com/kf/HTB1h_7ePpXXXXbEXVXXq6xXFXXXA/229354038/HTB1h_7ePpXXXXbEXVXXq6xXFXXXA.jpg',
				'https://ae01.alicdn.com/kf/HTB1k8sbPpXXXXcMXVXXq6xXFXXXT/229354038/HTB1k8sbPpXXXXcMXVXXq6xXFXXXT.jpg',
				'https://ae01.alicdn.com/kf/HTB1xV7uPpXXXXb5XpXXxh4dFXXX5/229354038/HTB1xV7uPpXXXXb5XpXXxh4dFXXX5.jpeg',
				'https://ae01.alicdn.com/kf/HTB1OGAzPFXXXXXmXVXXxh4dFXXX4/229354038/HTB1OGAzPFXXXXXmXVXXxh4dFXXX4.jpeg',
				'https://ae01.alicdn.com/kf/HTB1SGn5PpXXXXanaXXXxh4dFXXXK/229354038/HTB1SGn5PpXXXXanaXXXxh4dFXXXK.jpeg',
				'https://ae01.alicdn.com/kf/HTB1IFIkPpXXXXbFXFXXxh4dFXXXM/229354038/HTB1IFIkPpXXXXbFXFXXxh4dFXXXM.jpeg'
			]
		}, {
			asin: 'ALI_06',
			price: '1.59',
			rating: 4.9,
			reviewCount: 109,
			text: 'BellyLady Men Beard Shaping Styling Template Comb Men\'s Beards Combs Beauty Tool for Hair Beard Trim Templates',
			produced: 'BellyLady',
			link: 'http://s.click.aliexpress.com/e/7jUFJVm',
			images: [
				'https://ae01.alicdn.com/kf/HTB1oYE1liMnBKNjSZFoq6zOSFXaf.jpg?width=800&height=800&hash=1600',
				'https://ae01.alicdn.com/kf/HTB11BMVw3KTBuNkSne1q6yJoXXaX.jpg?width=800&height=800&hash=1600',
				'https://ae01.alicdn.com/kf/HTB1_.NRlpooBKNjSZFPq6xa2XXaD.jpg?width=800&height=800&hash=1600',
				'https://ae01.alicdn.com/kf/HTB1CF7Rw8yWBuNkSmFPq6xguVXaY.jpg?width=800&height=800&hash=1600'
			]
		}, {
			asin: 'ALI_07',
			price: '2.98',
			rating: 4.8,
			reviewCount: 760,
			text: 'HAICAR 650ML Hairdressing Spray Bottle Salon Barber Hair Tools Water Sprayer 180313 drop shipping',
			produced: 'HAICAR',
			link: 'http://s.click.aliexpress.com/e/K0CCsZw',
			images: [
				'https://ae01.alicdn.com/kf/HTB1LfsZdkKWBuNjy1zjq6AOypXax.jpg',
				'https://ae01.alicdn.com/kf/HTB1bro0dXmWBuNjSspdq6zugXXan.jpg',
				'https://ae01.alicdn.com/kf/HTB1hHdfduSSBuNjy0Flq6zBpVXaP.jpg',
				'https://ae01.alicdn.com/kf/HTB1pDpraJcnBKNjSZR0q6AFqFXaZ.jpg'
			]
		}, {
			asin: 'ALI_04',
			price: '2.56',
			rating: 4.6,
			reviewCount: 303,
			text: '100% Natural Men Growth Beard Oil Organic Beard Wax balm Avoid Beard Hair Loss Products Leave-In Conditioner for Groomed Growth',
			produced: 'MAANGE',
			link: 'http://s.click.aliexpress.com/e/96viQOk',
			images: [
				'https://ae01.alicdn.com/kf/HTB1_AIDeyqAXuNjy1Xdq6yYcVXas.jpg',
				'https://ae01.alicdn.com/kf/HTB1iiO1cqLN8KJjSZFvq6xW8VXaK.jpg',
				'https://ae01.alicdn.com/kf/HTB1i1btg26H8KJjSspmq6z2WXXat.jpg',
				'https://ae01.alicdn.com/kf/HTB1hO2acqLN8KJjSZFGq6zjrVXaG.jpg'
			]
		}, {
			asin: 'ALI_09',
			price: '14.24',
			rating: 4.9,
			reviewCount: 2811,
			text: 'Professional Electric Hair Clipper Rechargeable Hair Trimmer Hair Cutting Machine To Haircut Beard Trimer Waterproof',
			produced: 'KaiRui',
			link: 'http://s.click.aliexpress.com/e/BBUtK9S',
			images: [
				'https://ae01.alicdn.com/kf/HTB1H6.kLXXXXXaLXFXXq6xXFXXXC/202058890/HTB1H6.kLXXXXXaLXFXXq6xXFXXXC.jpg?size=64407&height=672&width=800&hash=2732a243ab6706311592839900ba9e07',
				'https://ae01.alicdn.com/kf/HTB1BPkvLXXXXXcVXXXXq6xXFXXXs/202058890/HTB1BPkvLXXXXXcVXXXXq6xXFXXXs.jpg?size=103427&height=648&width=800&hash=4e8f378e883425a2b013a29ef2a1bc17',
				'https://ae01.alicdn.com/kf/HTB1vuIjLXXXXXbuXFXXq6xXFXXXX/202058890/HTB1vuIjLXXXXXbuXFXXq6xXFXXXX.jpg?size=82216&height=639&width=800&hash=a558058e508fb833d62f2bd79a7b3236',
				'https://ae01.alicdn.com/kf/HTB19CsiLXXXXXblXFXXq6xXFXXXH/202058890/HTB19CsiLXXXXXblXFXXq6xXFXXXH.jpg?size=136960&height=913&width=800&hash=8d9ff5b2c14935effb3291710fae49e0',
				'https://ae01.alicdn.com/kf/HTB1AxUbLXXXXXb3XVXXq6xXFXXXS/202058890/HTB1AxUbLXXXXXb3XVXXq6xXFXXXS.jpg?size=101424&height=677&width=800&hash=7075699e5625c9816e637074d0877c93'
			]
		}, {
			asin: 'ALI_10',
			price: '3.80',
			rating: 4.8,
			reviewCount: 1891,
			text: 'New Arrival Andrea Hair Growth Products Ginger Oil Hair Growth Faster Grow Hair Ginger Shampoo Stop Hair Loss Treatment',
			produced: 'MeiYanQiong',
			link: 'http://s.click.aliexpress.com/e/ceX90vmo',
			images: [
				'https://ae01.alicdn.com/kf/HTB1ULejaiLrK1Rjy1zdq6ynnpXaY/New-Arrival-Andrea-Hair-Growth-Products-Ginger-Oil-Hair-Growth-Faster-Grow-Hair-Ginger-Shampoo-Stop.jpg',
				'https://ae01.alicdn.com/kf/HTB1bNWfaffsK1RjSszbq6AqBXXas/New-Arrival-Andrea-Hair-Growth-Products-Ginger-Oil-Hair-Growth-Faster-Grow-Hair-Ginger-Shampoo-Stop.jpg',
				'https://ae01.alicdn.com/kf/HTB1LOSjac_vK1RkSmRyq6xwupXa3/New-Arrival-Andrea-Hair-Growth-Products-Ginger-Oil-Hair-Growth-Faster-Grow-Hair-Ginger-Shampoo-Stop.jpg',
				'https://ae01.alicdn.com/kf/HTB1PzshIL9TBuNjy1zbq6xpepXaM/New-Arrival-Andrea-Hair-Growth-Products-Ginger-Oil-Hair-Growth-Faster-Grow-Hair-Ginger-Shampoo-Stop.jpg'
			]
		}, {
			asin: 'ALI_11',
			price: '0.74 - 3.58',
			rating: 4.7,
			reviewCount: 1654,
			text: 'SHANGKE 24" 100g/pc Synthetic Ombre Kanekalon Braiding Hair Crochet Braids Hairstyles Hair Extensions Purple Pink Black',
			produced: 'SHANGKE',
			link: 'http://s.click.aliexpress.com/e/cSbFy1ni',
			images: [
				'https://ae01.alicdn.com/kf/HTB1e02DXa6qK1RjSZFmq6x0PFXaK.jpg',
				'https://ae01.alicdn.com/kf/HTB1hj1MevMTUeJjSZFKq6ygopXaW.jpg?size=486498&height=800&width=800&hash=afc91485a690bb86cad04e2a509c596a',
				'https://ae01.alicdn.com/kf/HTB11X0Il.l7MKJjSZFDq6yOEpXaW.jpg?size=368503&height=800&width=800&hash=b7a96a6c617d08ec59b77db3d2fc9cac',
				'https://ae01.alicdn.com/kf/HTB1up2MilUSMeJjy1zjq6A0dXXaZ.jpg?size=506602&height=800&width=800&hash=6df7118ad06270924667ef1ca5b5451d',
				'https://ae01.alicdn.com/kf/HTB10p_MilUSMeJjy1zjq6A0dXXax.jpg?size=467583&height=800&width=800&hash=4cc0d76c1b681865c9974270754027d9'
			]
		}, {
			asin: 'ALI_12',
			price: '22.11',
			rating: 4.9,
			reviewCount: 775,
			text: 'Kemei KM5031 11In1 Professional Electric Hair Clipper trimmer Haircut Shaver Beard Razor Styling Tools Rechargeable',
			produced: 'Kemei',
			link: 'http://s.click.aliexpress.com/e/cU3TKKYo',
			images: [
				'https://ae01.alicdn.com/kf/HTB1T1p3X0zvK1RkSnfoq6zMwVXa0/machine-cut-Kemei-KM5031-11In1-Professional-Electric-Hair-Clipper-trimmer-Haircut-Shaver-Beard-Razor-Styling-Tools.jpg',
				'https://ae01.alicdn.com/kf/HTB1kyM_XITxK1Rjy0Fgq6yovpXaH/machine-cut-Kemei-KM5031-11In1-Professional-Electric-Hair-Clipper-trimmer-Haircut-Shaver-Beard-Razor-Styling-Tools.jpg',
				'https://ae01.alicdn.com/kf/HTB16wQ7HbSYBuNjSspiq6xNzpXaT/machine-cut-Kemei-KM5031-11In1-Professional-Electric-Hair-Clipper-trimmer-Haircut-Shaver-Beard-Razor-Styling-Tools.jpg',
				'https://ae01.alicdn.com/kf/HTB1dTE9XODxK1Rjy1zcq6yGeXXaG/machine-cut-Kemei-KM5031-11In1-Professional-Electric-Hair-Clipper-trimmer-Haircut-Shaver-Beard-Razor-Styling-Tools.jpg'
			]
		}];
	}
}
